const USERS = {
    CAN_NOT_SEND_WELCOME_EMAIL: 'The contact is inactive. The welcome email can not be sent.',
    MAX_NUMBER_OF_USERS: 2000,
    MAX_NUMBER_OF_USERS_ALERT: 'Please select a maximum of 2000 users.',
    MAX_NUMBER_OF_USERS_ALERT_TITLE: 'Alert',
    NO_USERS_SELECTED: 'Please select at least one user.',
    IMPORT_USER_NEWSLETTERS_REQUIRED_FIELDS: [
        'QUESTION_OF_THE_WEEK',
        'WHAT_MATTERS',
        'and LAW_ALERTS',
    ],
    IMPORT_USER_REQUIREMENTS: {
        REQUIRED_FIELD_ID: 'required_requirement_4',
        NEWSLETTER_SUBSCRIPTION: {
            FIELD_ID: 'question_of_the_week_column',
            FIELD_TITLE: 'NEWSLETTERS',
            FIELD_SUB_DESCRIPTION:
                'QUESTION_OF_THE_WEEK, WHAT_MATTERS, and LAW_ALERTS: For each of the corresponding newsletter columns:',
            FIELD_SUB_DESCRIPTION_PUN:
                'QUESTION_OF_THE_WEEK, WHAT_MATTERS, MINERAL_PRODUCT_UPDATES, and LAW_ALERTS: For each of the corresponding newsletter columns:',
            FIELD_SUB_ADDITIONAL_DESCRIPTION:
                'Note: Users with the Employee or Learn Admin role do not receive newsletters.',
            FIELD_DESCRIPTION: [
                {
                    id: 'q_w_l_requirement_1',
                    title: 'Enter “1” to subscribe the user to these subscriptions.',
                },
                {
                    id: 'q_w_l_requirement_2',
                    title: 'Enter “0” to not subscribe the user to these subscriptions.',
                },
            ],
        },
    },
    EXPORT_USERS: {
        DESCRIPTION:
            'A maximum of 4000 users can be exported to a .CSV. We recommend that you use the available filters to export a subset of users.',
    },
    EMAIL_HISTORY_DESCRIPTION: 'Below are the last 15 emails sent to this user.',
    PPA_PARTNER_ASSIGNMENTS: {
        SHOW: 'Show PPA Partner Assignments',
        HIDE: 'Hide PPA Partner Assignments',
    },
    WELCOME_LITE_TEMPLATE: 'welcomeLite',
    WELCOME_TEMPLATE: 'welcome',
    GRANT_ACCESS_TEMPLATE: 'acaGrantAccess',
    MAX_NUMBER_OF_PRONOUNS_ALLOWED: 256,
    SEND_WELCOME_EMAIL: 'Send Welcome Email?',
    SEND_WELCOME_EMAIL_LINK: 'Send Welcome Email',
    ADD_ANOTHER_USER: 'Add another user',
    VIEW_AUDIT_TRAILS: 'View Audit Trail',
    VIEW_USER_COMMENT: 'View User Comments',
    IMPERSONATION: {
        SYS_ADMIN: 'System Administrator',
        GENESIS_ADMIN: 'Genesis Admin',
    },
    COMPANY_ADMIN_ROLE: 'Company Admin',
    CLIENT_ADMIN_ROLE_MAP_VALUE: 9,
    SIGN_IN_METHOD: {
        SINGLE_SIGN_ON: 'Single Sign-On',
        DIRECT_SIGN_IN: 'Direct Sign-In',
        DESCRIPTION:
            'Changing the sign-in method will be applied to this user immediately upon saving.',
        TITLE: 'Sign-in Method',
        HELP_TEXT: 'This setting can be used to override the default sign-in method for this role.',
    },
    MULTIPLE_COMPANY_MANAGEMENT: {
        PARENT_PARTNER_ADMIN_PILL: 'PARENT PARTNER ADMIN',
        TITLE: 'Multiple Company Management',
        SECTION_TITLE: 'Multiple Company Administrator Options',
        ASSIGN_ACCOUNTS: 'Assign Accounts',
        SAVE_BUTTON: 'Save settings',
        DISCLAIMER: 'Changes will not be made to this user until you click Save.',
        BUTTON_COLOR: 'primary',
        TOGGLE_LABEL: 'Parent Partner Admin',
        DISABLED_LABEL: 'Disabled',
        ENABLED_LABEL: 'Enabled',
        TOGGLE_DESCRIPTION:
            'Enable this option to assign multiple partner accounts to this partner admin. When enabled and partner accounts are assigned, this partner admin will be able to view, create, edit, and deactivate all partner and client companies and users for the assigned accounts.',
        PPA_CONFIRM_MODAL_DESCRIPTION_1: `<b>Warning:</b> Disabling the Parent Partner Admin toggle will remove all assigned accounts. <b>This cannot be undone.</b> <br /><br />Select <b>Confirm</b> to proceed and disable the Parent Partner Admin ability for this user, or <b>Cancel</b> to leave the Parent Partner Admin toggle enabled.`,
        PPA_CONFIRM_MODAL_TITLE: 'Disable Parent Partner Admin',
        MODAL_CANCEL: 'Cancel',
        MODAL_CONFIRM: 'Confirm',
        REMOVE_ALL_MODAL_TITLE: 'Remove All Assigned Accounts',
        REMOVE_ALL_MODAL_DESCRIPTION: `<b>Warning:</b> Clicking the Remove All button will remove all assigned accounts.<br /><br/> Select <b>Confirm</b> to proceed and remove all assignments for this user, or <b>Cancel</b> to leave the assignments intact.`,
        PARTNER_ADMIN: 'Partner Admin',
        CLIENT_ADMIN: 'Client Admin',
        AUDIT_TRAILS: {
            SUB_TITLE: 'Multiple Company Management',
        },
    },
    MULTIPLE_CLIENT_ADMIN: {
        MULTIPLE_CLIENT_ADMIN_PILL: 'MULTIPLE CLIENT ADMIN',
        COMPANY_ADMIN: 'Company Admin',
        TOGGLE_LABEL: 'Multiple Client Admin',
        TOGGLE_DESCRIPTION:
            'Enable this option to assign multiple client accounts to this client admin. When enabled and client accounts are assigned, this client admin will be able to view and edit the assigned client companies, and the rights to view, create, edit, and deactivate all users within those accounts.',
        CONFIRM_MODAL_TITLE: 'Disable Multiple Client Admin',
        CONFIRM_MODAL_DESCRIPTION: `<b>Warning:</b> Disabling the Multiple Client Admin toggle will remove all assigned accounts. <b>This cannot be undone.</b> <br /><br />Select <b>Confirm</b> to proceed and disable the Multiple Client Admin ability for this user, or <b>Cancel</b> to leave the Multiple Client Admin toggle enabled.`,
    },
    ASSIGN_ACCOUNTS: {
        TITLE: 'Assign Accounts',
        BACK: 'Back',
        BUTTON: {
            ADD: 'Add',
            IMPORT: 'Import Assignments',
            SUBMIT: 'Submit',
        },
        SEARCH_PLACEHOLDER: 'Search Partners',
        ACKNOWLEDGEMENT_DESCRIPTION:
            'Acknowledge that you confirm that this Parent Partner Admin should have rights to view, create, edit, and deactivate all companies and users on the assigned partner accounts.',
        REMOVE_ALL: 'Remove All',
        REMOVE: 'Remove',
        PRIMARY_ACCOUNT: 'PRIMARY ACCOUNT',
        CUSTOM_MESSAGE: {
            NO_DATA_AVAILABLE: 'No Data Available.',
            SEARCH_PARTNER: 'Search for a partner to display the list.',
            NO_MESSAGE: '',
        },
        PPA: {
            TITLE: 'Select Partners To Assign',
            SUBTITLE: 'Select and assign partner accounts to a Parent Partner Admin.',
            DESCRIPTION:
                "Search for partners by name, select them from the <b>Available Partners</b> table, and click <b>Add</b> to move them to <b>Selected Partners</b>. After reviewing the selections, check the acknowledgement and click <b>Submit</b> to save the PPA's partner assignments.",
        },
        MCA: {
            TITLE: 'Select Clients To Assign',
            SUBTITLE: 'Select and assign client accounts to a Multiple Client Admin.',
            DESCRIPTION:
                "Search for clients by name, select them from the <b>Available Clients</b> table, and click <b>Add</b> to move them to <b>Selected Clients</b>. After reviewing the selections, check the acknowledgement and click <b>Submit</b> to save the MCA's client assignments.",
            SEARCH_PLACEHOLDER: 'Search By Client Name',
            ACKNOWLEDGEMENT_DESCRIPTION:
                'Acknowledge that you confirm that this Client Admin should have rights to view the assigned client companies, and the rights to view, create, edit, and deactivate all users within those accounts.',
            CUSTOM_MESSAGE: {
                NO_DATA_AVAILABLE: 'No Data Available.',
                SEARCH_CLIENT: 'Search for a client to display the list.',
                NO_MESSAGE: '',
            },
        },
        IMPORT_ACCOUNTS: {
            TITLE: 'Import Assignments',
            DOWNLOAD_TEMPLATE: 'Download Template',
            UPLOAD_CSV: 'Upload CSV',
            TEMPLATE_INSTRUCTIONS: 'Instructions:',
            IMPORT_ACCOUNT_INSTRUCTIONS: [
                { id: 1, text: 'Select <b>Download Template.</b>' },
                {
                    id: 2,
                    text: 'Add the Company IDs that will be assigned to this user to manage.',
                },
                { id: 3, text: 'Save the CSV file.' },
                { id: 4, text: 'When you have the file ready, select <b>Upload File.</b>' },
            ],
            MCA_IMPORT_ACCOUNT_INSTRUCTIONS: [
                { id: 1, text: 'Select <b>Download Template.</b>' },
                {
                    id: 2,
                    text: 'Add the Client IDs for the client companies to assign to this user.',
                    note:
                        'Note: Client IDs can be found in the <a href="/reporting/administration-reports">Administration report</a>.',
                },
                { id: 3, text: 'Save the CSV file.' },
                { id: 4, text: 'When you have the file ready, select <b>Upload File.</b>' },
            ],
            BUTTONS: {
                CANCEL: 'Cancel',
                DOWNLOAD_TEMPLATE: 'Download Template',
                UPLOAD_FILE: 'Upload File',
            },
            FAILURE: {
                TEMPLATE_INSTRUCTIONS: 'Instructions:',
                DISCLAIMER_TEXT: 'Import failed for some or all rows.',
                DOWNLOAD_BUTTON: {
                    TEXT_1: 'Download',
                    TEXT_2: 'the failed rows.',
                },
                CLOSE_BUTTON: 'Close',
            },
            STATUS: {
                SUCCESS: 'Successfully added imported partners to the selected partners list.',
                MCA_SUCCESS: 'Successfully added imported clients to the selected clients list.',
                FAILURE: 'Assignments were not successfully imported.',
                PARTIAL_SUCCESS: 'Import failed for some assignments.',
                INVALID_FILE_TYPE: 'You are only allowed to upload a CSV document (.csv).',
            },
        },
    },
    PRIMARY_CHECK_MODAL_DESCRIPTION:
        "You are about to deactivate the <b>company's primary admin</b>. After deactivation, you can assign a new company admin as the primary user for the same company.",
    SWITCH_ACCOUNT_HEADER: {
        VIEWING_PREFIX: 'You are viewing:',
        PRIMARY_SUFFIX: ' - Primary Account',
        BUTTON_LABEL: 'Switch Account',
    },
    SWITCH_ACCOUNT_MODAL: {
        BUTTON: {
            CANCEL: 'Cancel',
            CONFIRM: 'Confirm',
        },
        PRIMARY_ACCOUNT: 'PRIMARY ACCOUNT',
        SWITCH_ACCOUNT: 'Switch Account',
        CURRENTLY_MANAGING: 'Currently managing:',
    },
    IMPERSONATION_MODAL: {
        BUTTON: {
            OK: 'OK',
            CANCEL: 'CANCEL',
        },
        TITLE: 'CAUTION',
        DESCRIPTION: 'Are you sure you would like to end this impersonation session?',
    },
    IMPERSONATION_HEADER: 'You are impersonating:',
    IMPERSONATION_END_SESSION_BUTTON: 'End Session',
};

export default USERS;
